'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _searchTerms = require('../actions/search-terms');

var searchTerms = function searchTerms(state, action) {
	switch (action.type) {
		case _searchTerms.KEYWORD_SELECTED:
			return Object.assign({}, state, { selectedSearchKeyword: action.selectedKeyword });
		case _searchTerms.LOCATION_SELECTED:
			return Object.assign({}, state, { selectedSearchLocation: action.selectedLocation });
		case _searchTerms.INSURER_SELECTED:
			return Object.assign({}, state, { selectedSearchInsurer: action.selectedInsurer });
		case _searchTerms.SEARCH_TEXT_CHANGED:
			return Object.assign({}, state, { searchText: action.text });
		case '@@router/LOCATION_CHANGE':
			return action.payload && action.payload.pathname && action.payload.pathname === '/' ? Object.assign({}, state, { selectedSearchKeyword: null, selectedSearchLocation: null, selectedSearchInsurer: null, searchText: null }) : state;
		default:
			return state || {};
	}
};
exports.default = searchTerms;